<script>
/**
 * ****************************************************************************
 * @description     :   Switch Component
 * @created at      :   2022/03/24
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   STworks
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
import _ from 'lodash-uuid';
/**
 * Import template
 */
import template from './template.html';

/**
 * Define content of switch component
 */
var AnsSwitch = {
    template: template,
    props: {
        id: String,
        label: String,
        checkboxLabel: String,
        itemClass: String,
        labelClass: String,
        inputClass: String,
        isShowCheckbox: {
            type: Boolean,
            default: false
        },
        modelValue: {
            type: String,
            default: '0'
        },
        isDisabled: Boolean,
        onChange: Function
    },
    emits: ['update:modelValue'],
    computed: {
        value() {
            return this.modelValue == '1';
        }
    },
    data() {
        return {
            newId: _.uuid()
        };
    },
    mounted() {
        if (this.id && this.id != '') {
            this.newId = this.id;
        }
    },
    methods: {
        /**
         * click change value input checkbox
         * -----------------------------------------
         * @author : QuyPN - 2023/03/28 - create
         * @params :
         * @access : private
         */
        updateInput(e) {
            const value = this.value ? '0' : '1';
            this.$emit('update:modelValue', value);
            if (this.onChange) {
                this.onChange(e, value);
            }
        }
    }
};
export default AnsSwitch;
</script>
